export const BLUE       = "#1B4FD8";
export const NAVY       = "#0F2A6B";
export const LIGHT      = "#EEF3FF";
export const TEXT       = "#111827";
export const MUTED      = "#6B7280";
export const GREEN      = "#16A34A";
export const GREEN_LIGHT= "#F0FDF4";
export const GREEN_BORD = "#86EFAC";

export const QUICK_Q_PHONE = "9379200710";
export const FORMSPREE_ID  = "xjgjbobd";

export const GMAPS_URL = "https://www.google.com/maps/search/?api=1&query=Brookville,+Ohio+45309";
export const AMAPS_URL = "https://maps.apple.com/?q=Brookville,+Ohio+45309";
export const BROOKVILLE_LAT = 39.8334;
export const BROOKVILLE_LON = -84.4138;

export const WINTER_MONTHS = [0, 1, 2, 10, 11];
export const isWinter = WINTER_MONTHS.includes(new Date().getMonth());

export const DAYS_OF_WEEK = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
export const TIME_PREFS = ["Morning","Afternoon","Evening"];

export const COMBO_SAVINGS = {
  sedan:      20,
  suv:        20,
  largetruck: 20,
};

export const PRICING = {
  combo:    { sedan: 200, suv: 240, largetruck: 280 },
  interior: { sedan: 120, suv: 140, largetruck: 160 },
  exterior: { sedan: 100, suv: 120, largetruck: 140 },
};

export const VEHICLE_TYPES = [
  { id:"sedan",    label:"Sedan",         examples:"Civic, Camry, Coupe",       img:"https://images.unsplash.com/photo-1555215695-3004980ad54e?w=500&q=80&fit=crop" },
  { id:"suv",      label:"SUV",           examples:"CR-V, Equinox, RAV4",        img:"/vehicle-suv.jpg" },
  { id:"fullsize", label:"Full-Size SUV", examples:"Tahoe, Expedition, Yukon",   img:"/vehicle-fullsize.jpg" },
  { id:"truck",    label:"Truck",         examples:"F-150, Silverado, RAM 1500", img:"/vehicle-truck.jpg" },
];

export const CONDITIONS = [
  { id:"everyday", label:"Everyday Clean",      color:"#16A34A", dot:"#22C55E", icon:"🟢", desc:"Light dust, minor surface dirt, or regular weekly use. Great for keeping things maintained." },
  { id:"love",     label:"Could Use Some Love", color:"#CA8A04", dot:"#EAB308", icon:"🟡", desc:"Light pet hair, light stains, light mud, or a few weeks of general buildup." },
  { id:"reset",    label:"Ready for a Reset",   color:"#EA580C", dot:"#F97316", icon:"🟠", desc:"Heavy pet hair, multiple noticeable stains, or hasn't been properly cleaned in a while." },
  { id:"refresh",  label:"Full Refresh Needed", color:"#DC2626", dot:"#EF4444", icon:"🔴", desc:"Extensive buildup or heavy staining throughout. A photo may be requested before confirming." },
];

export const SERVICES = [
  {
    id:"combo", title:"Full Interior + Exterior", badge:"Best Value", bestFor:"Best Overall Value",
    desc:"Interior and exterior done together in one appointment. Every surface inside and out gets full attention from start to finish. One visit, completely done.",
    time:"5 to 7 hrs avg", priceFrom:"From $200", featured:true,
    photos:[
      "/combo-interior.avif",
      "/combo-exterior.jpg",
    ],
  },
  {
    id:"interior", title:"Interior Detail", badge:null, bestFor:"Best for Freshening Up",
    desc:"Full vacuum throughout, wipe-down of every surface, leather and upholstery cleaning, door jambs, vents, cup holders, and streak-free interior glass.",
    time:"3 to 4 hrs avg", priceFrom:"From $120",
    photos:[
      "/interior-1.jpg",
      "/interior-2.jpg",
    ],
  },
  {
    id:"exterior", title:"Exterior Detail", badge:null, bestFor:"Best First Impression",
    desc:"Full hand wash with safe, paint-friendly chemicals. No scratches. Tires shined, wheels and rims fully scrubbed, exterior glass cleaned. Car leaves noticeably cleaner and fresher.",
    time:"3 to 4 hrs avg", priceFrom:"From $100",
    photos:[
      "/exterior-1.jpg",
      "/exterior-2.jpg",
    ],
  },
];

export const REVIEWS = [
  { name:"Gary M.",    review:"Dropped my truck off and got it back looking great. The wheels were spotless and the interior was cleaner than when I bought it." },
  { name:"Denise R.",  review:"Had a lot of dog hair built up all over the seats and carpet. It came back completely clean. Every seat, every floor mat. Will definitely be back." },
  { name:"Russell T.", review:"Got the exterior done. Clean car, fair price. Will book again." },
  { name:"Melissa K.", review:"Really impressed with how thorough everything was. Did the full interior and exterior on my SUV. Came back looking like it just came off the lot. Highly recommend." },
];

export const FAQS = [
  { q:"Do you come to me, or do I come to you?", a:"Both. For mobile, service comes to your location, whether that is your home, workplace, or wherever the car is parked. For drop-off, bring the car to the Brookville, Ohio location. Your call." },
  { q:"How long does a detail take?", a:"A standard interior detail runs about 3 to 4 hours. Exterior only is also about 3 to 4 hours. A full interior and exterior together typically takes 7 to 8 hours. Keep in mind that heavier buildup, pet hair, staining, or a larger vehicle will add time on top of those estimates. The dirtier the car, the longer it takes to do it right." },
  { q:"Is mobile available year-round?", a:"Mobile runs spring through fall, available through approximately late October. When temps consistently drop below 35 degrees, usually November through March, only drop-off is available. Drop-off is open year-round." },
  { q:"What do I need if you come to me?", a:"An outdoor water hookup and an electrical outlet nearby. Everything else is brought on-site. For drop-off, everything is handled at the Brookville location." },
  { q:"What vehicles do you work on?", a:"Sedans, SUVs, full-size SUVs like the Tahoe or Expedition, and trucks. Not sure if yours qualifies? Just ask." },
  { q:"Is there a travel charge?", a:"Within roughly 30 minutes of Brookville, mobile service is included at no extra charge. Further out, a small travel rate may apply. It is always confirmed before anything is locked in. Drop-off always has no travel charge." },
  { q:"How do I pay?", a:"Cash, card, CashApp, Venmo, and PayPal. Payment is collected at completion." },
  { q:"Will the same person always work on my car?", a:"Yes, always. No crew, no hand-offs. Same person, same process, every time." },
  { q:"Do you offer recurring plans?", a:"Yes. If that is something you are interested in, bring it up when we connect and I will figure out what works for you." },
];

export const DAYS_OF_WEEK_FULL = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];

export function getVehicleTier(label) {
  if (!label) return null;
  if (label === "Sedan") return "sedan";
  if (label === "SUV")   return "suv";
  return "largetruck";
}
export function getServiceKey(title) {
  if (!title) return null;
  if (title.includes("Full Interior")) return "combo";
  if (title.includes("Interior"))      return "interior";
  return "exterior";
}
export function lookupPrice(vLabel, sTitle) {
  const tier = getVehicleTier(vLabel);
  const key  = getServiceKey(sTitle);
  if (!tier || !key) return null;
  return PRICING[key]?.[tier] ?? null;
}
export function haversine(lat1,lon1,lat2,lon2) {
  const R=3958.8,dLat=(lat2-lat1)*Math.PI/180,dLon=(lon2-lon1)*Math.PI/180;
  const a=Math.sin(dLat/2)**2+Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLon/2)**2;
  return R*2*Math.asin(Math.sqrt(a));
}
export async function fetchZipData(zip) {
  try {
    const res=await fetch(`https://api.zippopotam.us/us/${zip}`);
    if(!res.ok)return null;
    const d=await res.json();
    return{lat:parseFloat(d.places[0].latitude),lon:parseFloat(d.places[0].longitude),city:d.places[0]["place name"],state:d.places[0]["state abbreviation"]};
  } catch{return null;}
}
